/**
 * @param {Object} props
 * @param {string | undefined} [props.className]
 * @returns {React.ReactElement} The rendered component
 */
const PencilIcon = ({ className }) => (
  <svg
    className={className}
    width="25px"
    height="23px"
    viewBox="0 0 400 400"
    version="1.2"
    baseProfile="tiny"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill="currentColor"
      d="M380 284.1c-.5-2.4-1.6-4.6-3.3-6.2L104.1 9.6c-6-6.2-14-9.6-22.6-9.6C73 0 65 3.4 59 9.5L9.2 60.2C-3 72.7-3 93.1 9.2 105.6l.1.1 271.3 269.9c1.6 1.6 3.7 2.8 6 3.2l99 20.9c.8.2 1.7.3 2.5.3 3.1 0 6.1-1.2 8.4-3.5 2.9-2.8 4.1-6.9 3.3-10.8L380 284.1zm-91 66.2L59.7 122.1l61.8-61.8 230.5 227-63 63zM26.3 76.9l49.8-50.6c1.5-1.5 3.4-2.3 5.4-2.3 2 0 3.9.8 5.6 2.5l17.3 17.1-61.7 61.7-16.4-16.4c-3.2-3.4-3.2-8.7 0-12zM313.1 360l47.9-47.9 11.8 60.5-59.7-12.6z"
    />
  </svg>
);

export default PencilIcon;
